<template>
  <div style="width:100%;height:100%">
    <iframe 
            :src="iframeUrl"
            frameborder="0"
            width="100%"
            height="100%"
            allowtransparency></iframe>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iframeUrl: "",
      tonken: "",
    };
  },
  methods: {
    // 小毛驴报表
    getpage () {
      if(window.location.host == "bimp.console.detu.com") {
        this.iframeUrl = `//dashboard.detu.com/wd/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("bimp.test.console.donkeysgo.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd-test/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("bimp.test.console.detu.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd-test/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("supervision.console.detu.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("bimp.console.dev.donkeysgo.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd-test/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("bimp.gh.console.detu.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("ys.console.detu.com")) {
        this.iframeUrl = `//dashboard.detu.com/wd/index.html?token=${this.tonken}&${Date.now()}`;
      } else if (window.location.host.startsWith("supv-yc.console.detu.com")) {
        this.iframeUrl = `//dashboard.detu.com/yc/index.html?token=${this.tonken}&${Date.now()}`;
      }
    },
  },
  created () {
    this.tonken = sessionStorage.getItem("token");
  },
  mounted () {
    this.getpage();
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/main.vue